msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-11 17:28+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: zh-CN\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: formatTs(i18n, invitation.expires_at)
#: src/components/InvitationsInbox.tsx
msgid " · Expires {0}"
msgstr " · 到期于 {0}"

#. placeholder {0}: formatTs(i18n, invitation.decided_at)
#: src/components/InvitationsInbox.tsx
msgid " · Handled {0}"
msgstr " · 处理于 {0}"

#. placeholder {0}: member.owner_name
#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid " · owned by {0}"
msgstr " · 所有者：{0}"

#: src/components/ReadOnlyInteraction.tsx
msgid " · Required"
msgstr " · 必填"

#: src/components/DescriptionHistoryModal.tsx
msgid ": updated the description"
msgstr ": 修改了说明"

#. placeholder {0}: formatTs(i18n, invitation.created_at)
#: src/components/InvitationsInbox.tsx
msgid "· Created {0}"
msgstr "· 创建于 {0}"

#. placeholder {0}: preview.channel_count
#. placeholder {1}: preview.thread_count
#: src/components/ServerMemberRemovalControl.tsx
msgid "{0, plural, one {# channel membership} other {# channel memberships}} and {1, plural, one {# thread membership} other {# thread memberships}} will be removed."
msgstr "将移除{0, plural, one { # 项频道成员关系} other { # 项频道成员关系}}和{1, plural, one { # 项话题成员关系} other { # 项话题成员关系}}。"

#. placeholder {0}: channel.member_count
#: src/components/Settings/ChannelManagementSurface.tsx
msgid "{0, plural, one {# member} other {# members}}"
msgstr "{0, plural, one {# 位成员} other {# 位成员}}"

#. placeholder {0}: onlineUserIds.length
#: src/components/ChannelPresenceList.tsx
msgid "{0, plural, one {# person online} other {# people online}}"
msgstr "{0, plural, one {# 人在线} other {# 人在线}}"

#. placeholder {0}: people.length
#: src/components/ProjectMembersPage.tsx
msgid "{0, plural, one {# visible member} other {# visible members}}"
msgstr "{0, plural, one {# 位可见成员} other {# 位可见成员}}"

#. placeholder {0}: tasks.length - MAX_ACTIVE_TASKS_PER_CHANNEL
#: src/components/ChannelList.tsx
msgid "{0, plural, one {+# active task} other {+# active tasks}}"
msgstr "{0, plural, one {+# 个进行中的任务} other {+# 个进行中的任务}}"

#. placeholder {0}: member.display_name
#: src/components/MemberProjectProfilePopover.tsx
msgid "{0} Project profile"
msgstr "{0} 的项目资料"

#: src/components/ZoneChannelGroup.tsx
msgid "{unread} unread in {accessibleName}"
msgstr "{accessibleName} 中有 {unread} 条未读消息"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "@Everyone notifies current channel members and is subject to server rate limits."
msgstr "@Everyone 由服务器按当前频道成员计算并限流；客户端不能选择或扩大收件人。"

#: src/components/InvitationsInbox.tsx
msgid "← Back"
msgstr "← 返回"

#. placeholder {0}: work.active
#: src/components/MemberProjectProfilePopover.tsx
msgid "<0>{0}</0> active"
msgstr "<0>{0}</0> 个进行中"

#. placeholder {0}: work.completed
#: src/components/MemberProjectProfilePopover.tsx
msgid "<0>{0}</0> completed"
msgstr "<0>{0}</0> 个已完成"

#. placeholder {0}: work.open
#: src/components/MemberProjectProfilePopover.tsx
msgid "<0>{0}</0> open"
msgstr "<0>{0}</0> 个待处理"

#. placeholder {0}: invitation.agent_name || invitation.agent_id
#. placeholder {1}: invitation.channel_name ? `#${invitation.channel_name}` : invitation.channel_id
#: src/components/InvitationsInbox.tsx
msgid "<0>Invite agent</0> <1>{0}</1> to channel <2>{1}</2>"
msgstr "<0>邀请 Agent</0> <1>{0}</1> 加入频道 <2>{1}</2>"

#. placeholder {0}: zone.name
#: src/components/CreateChannelDialog.tsx
msgid "▦ Zone: {0}"
msgstr "▦ 分区：{0}"

#: src/components/ChannelStatusCard.tsx
msgid "⚫ Offline"
msgstr "⚫ 离线"

#: src/components/MutedChannelIndicator.tsx
msgid "🔕 Muted"
msgstr "🔕 已静音"

#: src/components/ChannelStatusCard.tsx
msgid "🟢 Online"
msgstr "🟢 在线"

#: src/components/ZoneManagementDialog.tsx
msgid "1–100 characters. Names must be distinct within this Project, ignoring case."
msgstr "1–100 个字符。名称在此项目内必须唯一，不区分大小写。"

#: src/components/ZoneManagementDialog.tsx
msgid "A Zone with this name already exists. Choose a distinct name."
msgstr "此名称的分区已存在，请使用其他名称。"

#: src/components/InvitationsInbox.tsx
msgid "Accept"
msgstr "同意"

#: src/components/InvitationsInbox.tsx
msgid "Accepted"
msgstr "已同意"

#: src/components/InviteLinksModal.tsx
msgid "Active"
msgstr "正常"

#. placeholder {0}: channel.name
#: src/components/ChannelList.tsx
msgid "Active tasks in {0}"
msgstr "{0} 中进行中的任务"

#: src/components/AddMemberModal.tsx
msgid "Add"
msgstr "添加"

#: src/components/ProjectMembersPage.tsx
msgid "Add Agent"
msgstr "添加 Agent"

#: src/components/AddMemberModal.tsx
#: src/components/MemberList.tsx
#: src/components/ProjectMembersPage.tsx
msgid "Add member"
msgstr "添加成员"

#: src/components/ProjectMembersPage.tsx
msgid "Add member options"
msgstr "添加成员选项"

#: src/components/ServerMembersPanel.tsx
msgid "Add to this channel"
msgstr "添加到此频道"

#: src/components/ProjectMembersPage.tsx
msgid "Admin"
msgstr "管理员"

#: src/components/MemberProjectProfilePopover.tsx
msgid "ADMIN"
msgstr "管理员"

#: src/components/ProjectMemberRoleControl.tsx
msgid "Admins can manage ordinary Human and Agent memberships in this Project."
msgstr "管理员可以管理此项目中的普通成员和智能体成员关系。"

#: src/components/ChannelStatusCard.tsx
#: src/components/ProjectMembersPage.tsx
#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Agent"
msgstr "Agent"

#: src/components/ProjectMembersPage.tsx
msgid "Agent added, but the Project member list could not be refreshed"
msgstr "Agent 已添加，但无法刷新项目成员列表"

#: src/components/InvitationsInbox.tsx
msgid "Agent invitations"
msgstr "Agent 邀请"

#: src/components/InviteLinksModal.tsx
msgid "Agent selection allowed after joining"
msgstr "加入后可选择 Agent"

#: src/components/ProjectMembersPage.tsx
msgid "Agents"
msgstr "Agent"

#: src/components/ChannelFilterSidebar.tsx
#: src/components/InvitationsInbox.tsx
#: src/components/ProjectMembersPage.tsx
msgid "All"
msgstr "全部"

#: src/components/NotificationPrefDropdown.tsx
msgid "All messages"
msgstr "所有消息"

#: src/components/InviteLinksModal.tsx
msgid "Allow invited Humans to choose their active agents"
msgstr "允许受邀用户选择自己启用的 Agent"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Allow messages without mentions"
msgstr "允许非提及送达"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "An @mention is currently required"
msgstr "当前需要 @ 提及"

#: src/components/InviteLinksModal.tsx
msgid "Anyone who has not accepted it will no longer be able to join."
msgstr "尚未接受邀请的人将无法再通过此链接加入。"

#: src/components/MemberProjectProfilePopover.tsx
msgid "APP"
msgstr "应用"

#: src/components/ChannelSettingsModal.tsx
msgid "Archive failed"
msgstr "归档失败"

#: src/components/ArchivedChannelsPanel.tsx
#: src/components/ChannelRow.tsx
msgid "Archived"
msgstr "已归档"

#: src/components/ArchivedChannelsPanel.tsx
msgid "Archived channels"
msgstr "已归档频道"

#: src/components/ZoneManagementDialog.tsx
msgid "Archived channels also prevent deletion. No channel will be deleted or reassigned."
msgstr "已归档频道也会阻止删除。不会删除或重新分配任何频道。"

#: src/components/MemberProjectProfilePopover.tsx
msgid "Assigned"
msgstr "负责人"

#: src/components/ChannelSettingsModal.tsx
msgid "Assigned at creation. Placement is read-only and does not affect channel access."
msgstr "位置在创建时指定，之后无法修改，且不影响频道访问权限。"

#: src/components/TurnRoutingPolicyControl.tsx
msgid "Borgee decides eligible turns"
msgstr "由 Borgee 决定响应轮次"

#: src/components/TurnRoutingPolicyControl.tsx
msgid "Borgee decides when eligible agents receive a turn in this channel."
msgstr "Borgee 决定符合条件的 Agent 何时在此频道获得响应轮次。"

#: src/components/TurnRoutingPolicyControl.tsx
msgid "Borgee decides when eligible agents receive a turn. In 1H+1A with mentions off, ordinary human messages give the agent a turn; otherwise explicit @ targets do. Threads have independent policies."
msgstr "Borgee 决定符合条件的 Agent 何时获得响应轮次。一个人类和一个 Agent 的对话中，关闭提及时，普通人类消息会让 Agent 响应；其他情况由明确的 @ 提及决定。讨论串使用独立策略。"

#: src/components/TurnRoutingPolicyControl.tsx
msgid "Borgee turn routing"
msgstr "Borgee 轮次路由"

#: src/components/ZoneManagementDialog.tsx
msgid "Built-in"
msgstr "内置"

#: src/components/AddMemberModal.tsx
#: src/components/ChannelSettingsModal.tsx
#: src/components/CreateChannelDialog.tsx
#: src/components/CreateServerModal.tsx
#: src/components/DescriptionEditor.tsx
#: src/components/InviteLinksModal.tsx
#: src/components/KickConfirmModal.tsx
#: src/components/ProjectMemberRoleControl.tsx
#: src/components/ProjectMembersPage.tsx
#: src/components/ServerMemberRemovalControl.tsx
#: src/components/ServerSettings/ServerMembersPanel.tsx
#: src/components/ZoneManagementDialog.tsx
msgid "Cancel"
msgstr "取消"

#: src/components/HumanDetailView.tsx
msgid "Cannot open chat."
msgstr "无法打开聊天。"

#: src/components/ProjectMemberRoleControl.tsx
msgid "Change {displayName} Project role"
msgstr "更改 {displayName} 的项目角色"

#. placeholder {0}: channelDisplayName(target)
#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Channel #{0} was deleted."
msgstr "频道 #{0} 已被删除。"

#: src/components/ChannelSettingsModal.tsx
msgid "Channel archived"
msgstr "频道已归档"

#: src/stores/useChannelStore.ts
msgid "Channel created, but its permissions could not be refreshed."
msgstr "频道已创建，但无法刷新其权限。"

#: src/components/ChannelSettingsModal.tsx
msgid "Channel deleted"
msgstr "频道已删除"

#: src/components/DescriptionEditor.tsx
msgid "Channel description"
msgstr "频道说明"

#: src/components/DescriptionEditor.tsx
msgid "Channel descriptions must be {DESCRIPTION_MAX_LENGTH} characters or fewer."
msgstr "频道说明不能超过 {DESCRIPTION_MAX_LENGTH} 个字符。"

#: src/components/ChannelSettingsModal.tsx
msgid "Channel is now private."
msgstr "频道已设为私有。"

#: src/components/ChannelSettingsModal.tsx
msgid "Channel is now public."
msgstr "频道已设为公开。"

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Channel management"
msgstr "频道管理"

#: src/components/ChannelSettingsModal.tsx
msgid "Channel moved."
msgstr "频道已移动。"

#: src/components/CreateChannelDialog.tsx
msgid "Channel name"
msgstr "频道名称"

#: src/components/ChannelSettingsModal.tsx
msgid "Channel name confirmation"
msgstr "确认频道名称"

#: src/components/ChannelView.tsx
msgid "Channel not found"
msgstr "找不到频道"

#: src/components/ChannelSettingsModal.tsx
msgid "Channel restored"
msgstr "频道已恢复"

#: src/lib/readonly.ts
msgid "Channel set to read-only"
msgstr "已设为只读"

#: src/components/ChannelView.tsx
msgid "Channel Settings"
msgstr "频道设置"

#: src/components/ChannelSettingsModal.tsx
msgid "Channel updated"
msgstr "频道已更新"

#: src/components/ChannelSettingsModal.tsx
msgid "Channel Zone"
msgstr "频道分区"

#: src/components/Sidebar.tsx
msgid "Channels"
msgstr "频道"

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Channels I created"
msgstr "我创建的频道"

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Channels I joined"
msgstr "我加入的频道"

#: src/components/ChannelSettingsModal.tsx
msgid "Channels in a named Zone stay in their original Project. Placement cannot be changed."
msgstr "位于命名分区中的频道会保留在原项目中，无法更改位置。"

#: src/components/ChannelView.tsx
#: src/components/HumanDetailView.tsx
msgid "Chat"
msgstr "聊天"

#: src/components/CreateChannelDialog.tsx
msgid "Choose Default or a named Zone. The channel’s visibility and membership stay independent."
msgstr "选择默认位置或命名分区。频道的可见性和成员关系保持独立。"

#: src/components/ProjectMembersPage.tsx
msgid "Choose one of your active Agents to add to this Project."
msgstr "选择一个你已启用的 Agent 加入此项目。"

#: src/components/DescriptionHistoryModal.tsx
#: src/components/InviteLinksModal.tsx
msgid "Close"
msgstr "关闭"

#: src/components/KickConfirmModal.tsx
msgid "Confirm"
msgstr "确认"

#: src/components/InviteLinksModal.tsx
msgid "Copied"
msgstr "已复制"

#: src/components/InviteLinksModal.tsx
msgid "Copy invite link"
msgstr "复制邀请链接"

#: src/components/AddMemberModal.tsx
msgid "Could not add member."
msgstr "添加成员失败"

#: src/components/ProjectMembersPage.tsx
msgid "Could not add the Agent"
msgstr "无法添加 Agent"

#: src/components/ProjectMembersPage.tsx
msgid "Could not add the agent to this Project."
msgstr "无法将 Agent 添加到此项目。"

#: src/components/ReadonlyToggle.tsx
msgid "Could not change read-only setting."
msgstr "只读切换失败"

#: src/components/ProjectMemberRoleControl.tsx
msgid "Could not change this Project role."
msgstr "无法更改此项目角色。"

#: src/components/InvitationsInbox.tsx
msgid "Could not complete the action."
msgstr "操作失败"

#: src/components/InviteLinksModal.tsx
msgid "Could not copy the invite link. Copy it manually before closing this dialog."
msgstr "无法复制邀请链接，请在关闭此对话框前手动复制。"

#: src/components/InviteLinksModal.tsx
msgid "Could not create invite link."
msgstr "无法创建邀请链接。"

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Could not delete channel."
msgstr "删除失败"

#: src/components/ArchivedChannelsPanel.tsx
#: src/components/InvitationsInbox.tsx
msgid "Could not load data."
msgstr "加载失败"

#: src/components/DescriptionHistoryModal.tsx
msgid "Could not load edit history."
msgstr "加载编辑历史失败"

#: src/components/InviteLinksModal.tsx
msgid "Could not load invite links."
msgstr "无法加载邀请链接。"

#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Could not load members."
msgstr "无法加载成员。"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Could not load mention settings."
msgstr "无法加载提及设置。"

#: src/components/ProjectMembersPage.tsx
msgid "Could not load your Agents"
msgstr "无法加载你的 Agent"

#: src/components/ProjectMembersPage.tsx
msgid "Could not load your agents."
msgstr "无法加载你的 Agent。"

#: src/components/ZoneManagementDialog.tsx
msgid "Could not load Zones. Refresh Zones to load the current groups."
msgstr "无法加载分区，请刷新分区以加载当前分组。"

#: src/components/ServerMemberRemovalControl.tsx
msgid "Could not preview removal."
msgstr "无法预览移除影响。"

#: src/stores/useChannelStore.ts
msgid "Could not refresh channels and Zones."
msgstr "无法刷新频道和分区。"

#: src/components/ZoneManagementDialog.tsx
msgid "Could not refresh Zones. Please try again."
msgstr "无法刷新分区，请重试。"

#: src/components/KickConfirmModal.tsx
#: src/components/ServerMemberRemovalControl.tsx
#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Could not remove member."
msgstr "移除成员失败"

#: src/components/ArchivedChannelsPanel.tsx
msgid "Could not restore channel."
msgstr "恢复失败"

#: src/components/InviteLinksModal.tsx
msgid "Could not revoke invite link."
msgstr "无法撤销邀请链接。"

#: src/components/DescriptionEditor.tsx
msgid "Could not save channel description."
msgstr "保存频道说明失败"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Could not save Project settings."
msgstr "无法保存项目设置。"

#: src/components/ZoneManagementDialog.tsx
msgid "Could not save this change. Please try again."
msgstr "无法保存此更改，请重试。"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Could not update mention policy."
msgstr "提及策略更新失败"

#: src/components/InviteLinksModal.tsx
msgid "Create and copy invite link"
msgstr "创建并复制邀请链接"

#: src/components/CreateChannelDialog.tsx
#: src/components/Sidebar.tsx
msgid "Create channel"
msgstr "创建频道"

#: src/components/Sidebar.tsx
msgid "Create Channel"
msgstr "创建频道"

#: src/components/ZoneChannelGroup.tsx
msgid "Create channel in {accessibleName}"
msgstr "在{accessibleName}中创建频道"

#: src/components/CreateServerModal.tsx
#: src/components/PrimaryNavigationRail.tsx
msgid "Create Project"
msgstr "创建项目"

#: src/components/Sidebar.tsx
#: src/components/ZoneManagementDialog.tsx
msgid "Create Zone"
msgstr "创建分区"

#: src/components/MemberProjectProfilePopover.tsx
msgid "Created"
msgstr "创建时间"

#: src/components/CreateChannelDialog.tsx
msgid "Creating…"
msgstr "正在创建…"

#: src/components/MemberProjectProfilePopover.tsx
msgid "Current focus"
msgstr "当前重点"

#: src/components/ServerSidebar.tsx
msgid "Current Project"
msgstr "当前项目"

#: src/components/InvitationsInbox.tsx
msgid "Decline"
msgstr "拒绝"

#: src/components/InvitationsInbox.tsx
msgid "Declined"
msgstr "已拒绝"

#: src/components/ChannelSettingsModal.tsx
#: src/components/CreateChannelDialog.tsx
#: src/components/ZoneManagementDialog.tsx
msgid "Default (no Zone)"
msgstr "默认（无分区）"

#: src/components/CreateChannelDialog.tsx
msgid "Default is the ungrouped location. Placement cannot be changed after creation."
msgstr "默认位置不属于任何分区，创建后无法更改位置。"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Default is the virtual location for channels with no named Zone. Project members can see all named Zones, including empty ones."
msgstr "默认位置用于没有命名分区的频道。项目成员可以看到所有命名分区，包括空分区。"

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Delete"
msgstr "删除"

#. placeholder {0}: channelDisplayName(channel!)
#: src/components/ChannelSettingsModal.tsx
msgid "Delete #{0}"
msgstr "删除 #{0}"

#: src/components/ZoneManagementDialog.tsx
msgid "Delete <0>{selectedName}</0> from this Project. Only an empty Zone can be deleted."
msgstr "从此项目删除 <0>{selectedName}</0>。只能删除空分区。"

#. placeholder {0}: channelDisplayName(channel)
#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Delete channel #{0}"
msgstr "删除频道 #{0}"

#: src/components/ChannelSettingsModal.tsx
msgid "Delete failed"
msgstr "删除失败"

#: src/components/ZoneChannelGroup.tsx
#: src/components/ZoneManagementDialog.tsx
msgid "Delete Zone"
msgstr "删除分区"

#. placeholder {0}: zone.name
#: src/components/ZoneManagementDialog.tsx
msgid "Delete Zone: {0}"
msgstr "删除分区：{0}"

#: src/components/ZoneManagementDialog.tsx
msgid "Delete Zone?"
msgstr "删除分区？"

#: src/components/ProjectMemberRoleControl.tsx
msgid "Demote to Member"
msgstr "降级为成员"

#: src/components/CreateChannelDialog.tsx
msgid "Description (optional)"
msgstr "说明（可选）"

#: src/components/ChannelSettingsModal.tsx
msgid "Description <0>(optional)</0>"
msgstr "说明<0>（可选）</0>"

#: src/components/Sidebar.tsx
msgid "Direct Messages"
msgstr "私信"

#: src/components/HumanDetailView.tsx
msgid "DISPLAY NAME"
msgstr "显示名称"

#: src/components/Sidebar.tsx
msgid "DM"
msgstr "私信"

#: src/components/NotificationPrefDropdown.tsx
msgid "Do not disturb"
msgstr "不打扰"

#: src/components/ZoneManagementDialog.tsx
msgid "e.g. Customer experience"
msgstr "例如：客户体验"

#: src/components/ChannelHeader.tsx
msgid "Edit"
msgstr "编辑"

#: src/components/ChannelSettingsModal.tsx
msgid "EDIT CHANNEL"
msgstr "编辑频道"

#: src/components/DescriptionHistoryModal.tsx
msgid "Edit history"
msgstr "编辑历史"

#: src/lib/readonly.ts
msgid "Editing restored"
msgstr "已恢复编辑"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Emoji or short text"
msgstr "表情或短文本"

#: src/components/TurnRoutingPolicyControl.tsx
msgid "Enable Borgee turn routing for this channel"
msgstr "为此频道启用 Borgee 轮次路由"

#: src/lib/zoneNames.ts
msgid "Enter a Zone name."
msgstr "请输入分区名称。"

#: src/components/ZoneChannelGroup.tsx
msgid "Expanded for the selected channel"
msgstr "已为当前选中的频道展开"

#: src/components/InvitationsInbox.tsx
#: src/components/InviteLinksModal.tsx
msgid "Expired"
msgstr "已过期"

#: src/components/ServerMembersPanel.tsx
msgid "Failed to add member"
msgstr "添加成员失败"

#: src/components/CreateChannelDialog.tsx
msgid "Failed to create channel"
msgstr "创建频道失败"

#: src/components/ChannelView.tsx
msgid "Failed to join"
msgstr "加入失败"

#: src/components/ChannelView.tsx
msgid "Failed to leave"
msgstr "退出失败"

#: src/components/TurnRoutingPolicyControl.tsx
msgid "Failed to load Borgee turn routing"
msgstr "无法加载 Borgee 轮次路由"

#: src/components/ServerMembersPanel.tsx
msgid "Failed to load channel members."
msgstr "加载频道成员失败。"

#: src/components/ChannelSettingsModal.tsx
msgid "Failed to move channel"
msgstr "移动频道失败"

#: src/components/CreateChannelDialog.tsx
msgid "Failed to refresh Zones"
msgstr "刷新分区失败"

#: src/components/ServerMembersPanel.tsx
msgid "Failed to remove member"
msgstr "移除成员失败"

#: src/components/ChannelSettingsModal.tsx
msgid "Failed to save"
msgstr "保存失败"

#: src/components/ChannelSettingsModal.tsx
msgid "Failed to switch"
msgstr "切换失败"

#: src/components/TurnRoutingPolicyControl.tsx
msgid "Failed to update Borgee turn routing"
msgstr "无法更新 Borgee 轮次路由"

#: src/components/ServerMembersPanel.tsx
msgid "Failed to update policy"
msgstr "更新策略失败"

#: src/components/ChannelView.tsx
msgid "Files"
msgstr "文件"

#: src/components/ServerSettings/ServerProfilePanel.tsx
#: src/components/ServerSettingsSidebar.tsx
msgid "General"
msgstr "常规"

#: src/components/ZoneManagementDialog.tsx
msgid "Group related channels in the sidebar. A Zone does not change channel access or add members."
msgstr "在侧栏中将相关频道分组。分区不会改变频道访问权限，也不会添加成员。"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Group related channels in the sidebar. Channel access and membership remain independent."
msgstr "在侧栏中将相关频道分组。频道访问权限和成员关系保持独立。"

#. placeholder {0}: channelDisplayName(channel!)
#: src/components/ChannelSettingsModal.tsx
msgid "Hide #{0}"
msgstr "隐藏 #{0}"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Hide mention settings"
msgstr "收起提及设置"

#: src/components/HumanDetailView.tsx
#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Human"
msgstr "用户"

#: src/components/ProjectMembersPage.tsx
msgid "Humans"
msgstr "用户"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "ICON"
msgstr "图标"

#: src/components/CreateServerModal.tsx
msgid "Icon (optional)"
msgstr "图标（可选）"

#: src/lib/createServer.ts
msgid "Icon must be 500 characters or fewer."
msgstr "图标不能超过 500 个字符。"

#. placeholder {0}: inChannel.length
#: src/components/ServerMembersPanel.tsx
msgid "In this channel — {0}"
msgstr "频道成员 — {0}"

#: src/components/MemberProjectProfilePopover.tsx
msgid "In this Project"
msgstr "在此项目中"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Inherit agent settings"
msgstr "继承 agent 全局设置"

#: src/components/ChannelView.tsx
#: src/components/ServerSidebar.tsx
msgid "Insights"
msgstr "洞察"

#: src/components/ProjectMembersPage.tsx
msgid "Invite human"
msgstr "邀请用户"

#: src/components/InviteLinksModal.tsx
msgid "Invite link copied. It is shown here only until this dialog closes."
msgstr "邀请链接已复制，仅在此对话框关闭前显示。"

#: src/components/InviteLinksModal.tsx
msgid "Invite link history"
msgstr "邀请链接历史"

#: src/components/InviteLinksModal.tsx
msgid "Invite members"
msgstr "邀请成员"

#. placeholder {0}: invitation.requester_name || invitation.requested_by
#: src/components/InvitationsInbox.tsx
msgid "Invited by <0>{0}</0>"
msgstr "邀请人：<0>{0}</0>"

#. placeholder {0}: channelDisplayName(channel!)
#: src/components/ChannelView.tsx
msgid "Join #{0} to reply"
msgstr "加入 #{0} 后回复"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Join this channel to view member mention settings."
msgstr "加入频道后可查看成员提及设置。"

#: src/components/MemberProjectProfilePopover.tsx
msgid "Joined {joined}"
msgstr "加入于 {joined}"

#: src/components/ChannelView.tsx
msgid "Joining..."
msgstr "正在加入…"

#: src/components/ChannelView.tsx
msgid "Leave"
msgstr "退出"

#: src/components/ChannelView.tsx
msgid "Leave channel"
msgstr "退出频道"

#: src/components/InviteLinksModal.tsx
msgid "Let invited Humans choose their active agents after joining"
msgstr "允许受邀用户加入后选择自己启用的 Agent"

#: src/components/MemberProjectProfilePopover.tsx
msgid "Loading authorized task context…"
msgstr "正在加载有权访问的任务信息…"

#: src/components/Sidebar.tsx
msgid "Loading channels and Zones…"
msgstr "正在加载频道和分区…"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Loading Project settings…"
msgstr "正在加载项目设置…"

#: src/components/ServerMemberRemovalControl.tsx
msgid "Loading removal impact…"
msgstr "正在加载移除影响…"

#: src/components/ProjectMembersPage.tsx
msgid "Loading your Agents…"
msgstr "正在加载你的 Agent…"

#: src/components/ZoneManagementDialog.tsx
msgid "Loading Zones…"
msgstr "正在加载分区…"

#: src/components/ArchivedChannelsPanel.tsx
#: src/components/Settings/ChannelMentionControls.tsx
msgid "Loading…"
msgstr "正在加载…"

#. placeholder {0}: member.display_name
#: src/components/ProjectMembersPage.tsx
msgid "Manage {0}"
msgstr "管理 {0}"

#: src/components/ZoneChannelGroup.tsx
msgid "Manage {accessibleName}"
msgstr "管理{accessibleName}"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Manage Zones"
msgstr "管理分区"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Managing channel members is required to change agent mention policies."
msgstr "需要频道成员管理权限才能更改 agent 提及策略。"

#: src/components/ProjectMembersPage.tsx
msgid "Member"
msgstr "成员"

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Member count unavailable"
msgstr "成员数未知"

#: src/components/ChannelView.tsx
#: src/components/MemberList.tsx
#: src/components/ProjectMembersPage.tsx
#: src/components/ServerSidebar.tsx
msgid "Members"
msgstr "成员"

#: src/components/ChannelSettingsModal.tsx
msgid "Members, invitations, layouts, and other access derived from the current Project are removed. Only your new owner access is created in the target Project."
msgstr "当前项目中的成员、邀请、布局和其他关联访问权限将被移除。目标项目中只会为你创建新的所有者访问权限。"

#. placeholder {0}: members.length
#. placeholder {1}: online.length
#: src/components/ChannelStatusCard.tsx
msgid "Members: {0} (online {1})"
msgstr "成员：{0}（在线 {1}）"

#. placeholder {0}: agent.display_name
#: src/components/Settings/ChannelMentionControls.tsx
msgid "Mention policy for {0}"
msgstr "{0} 提及策略"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Mention settings"
msgstr "提及设置"

#: src/components/NotificationPrefDropdown.tsx
msgid "Mentions only"
msgstr "仅@提及"

#. placeholder {0}: user.display_name
#: src/components/Sidebar.tsx
msgid "Message {0}"
msgstr "向 {0} 发送消息"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Messages without mentions are also delivered"
msgstr "普通消息也会送达"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Messages without mentions are delivered only when the agent owner allows them."
msgstr "agent 非提及送达只在 agent 拥有者已允许时生效，服务器会拒绝越权设置。"

#. placeholder {0}: channelDisplayName(channel!)
#: src/components/ChannelSettingsModal.tsx
msgid "Move #{0}"
msgstr "移动 #{0}"

#. placeholder {0}: channelDisplayName(channel)
#: src/components/ChannelSettingsModal.tsx
msgid "Move #{0} to another Project"
msgstr "将 #{0} 移动到其他项目"

#: src/components/ChannelSettingsModal.tsx
msgid "Move channel"
msgstr "移动频道"

#: src/components/ChannelSettingsModal.tsx
msgid "Move to another Project"
msgstr "移动到其他项目"

#: src/components/MuteButton.tsx
msgid "Mute"
msgstr "静音"

#: src/components/MutedChannelIndicator.tsx
msgid "Muted"
msgstr "已静音"

#: src/components/PrimaryNavigationRail.tsx
msgid "My Agents"
msgstr "我的 Agent"

#: src/components/PrimaryNavigationRail.tsx
msgid "My Computers"
msgstr "我的电脑"

#: src/components/PrimaryNavigationRail.tsx
msgid "My Tasks"
msgstr "我的任务"

#: src/components/ChannelSettingsModal.tsx
msgid "Name"
msgstr "名称"

#: src/components/ZoneManagementDialog.tsx
msgid "Named groups for this Project’s channels. Channel permissions are managed on each channel."
msgstr "为此项目的频道创建命名分组。频道权限在各频道中管理。"

#: src/components/ZoneManagementDialog.tsx
msgid "Named Zone"
msgstr "命名分区"

#: src/lib/zoneNames.ts
msgid "Names cannot contain control characters."
msgstr "名称不能包含控制字符。"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "No agent members need individual settings."
msgstr "没有 agent 成员需要单独设置。"

#: src/components/InviteLinksModal.tsx
msgid "No agent selection"
msgstr "不可选择 Agent"

#: src/components/ArchivedChannelsPanel.tsx
msgid "No archived channels"
msgstr "暂无归档频道"

#: src/components/ServerMemberRemovalControl.tsx
msgid "no channel memberships"
msgstr "未加入任何频道"

#: src/components/ChannelList.tsx
msgid "No channels"
msgstr "暂无频道"

#: src/components/DescriptionHistoryModal.tsx
msgid "No edit history"
msgstr "暂无编辑记录"

#: src/components/ProjectMembersPage.tsx
msgid "No eligible Agents are available."
msgstr "没有符合条件的 Agent。"

#: src/components/InvitationsInbox.tsx
msgid "No invitations"
msgstr "暂无邀请记录"

#: src/components/InviteLinksModal.tsx
msgid "No invite links yet."
msgstr "暂无邀请链接。"

#: src/components/ProjectMembersPage.tsx
msgid "No matching members."
msgstr "没有匹配的成员。"

#: src/components/ServerMembersPanel.tsx
msgid "No members yet"
msgstr "暂无成员"

#: src/components/MemberProjectProfilePopover.tsx
msgid "No open work in the authorized task view."
msgstr "有权查看的任务中没有待处理工作。"

#: src/components/InvitationsInbox.tsx
msgid "No pending invitations"
msgstr "暂无待处理邀请"

#: src/components/ServerSidebar.tsx
msgid "No Project selected"
msgstr "未选择项目"

#: src/components/ZoneChannelGroup.tsx
msgid "No visible channels"
msgstr "没有可见频道"

#: src/components/ChannelStatusCard.tsx
msgid "None"
msgstr "无"

#: src/components/ServerMembersPanel.tsx
msgid "Not in this channel"
msgstr "尚未加入此频道"

#: src/components/NotificationPrefDropdown.tsx
msgid "Notification preference"
msgstr "通知偏好"

#: src/components/CreateChannelDialog.tsx
msgid "Only invited members can see this channel."
msgstr "只有受邀成员可以看到此频道。"

#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Only the Project owner can manage members."
msgstr "只有项目所有者可以管理成员。"

#: src/components/ProjectMembersPage.tsx
msgid "Open direct message"
msgstr "打开私信"

#. placeholder {0}: member.display_name
#: src/components/ProjectMembersPage.tsx
msgid "Open direct message with {0}"
msgstr "打开与 {0} 的私信"

#: src/components/PrimaryNavigationRail.tsx
msgid "Overview"
msgstr "概览"

#: src/components/ProjectMembersPage.tsx
msgid "Owner"
msgstr "所有者"

#: src/components/MemberProjectProfilePopover.tsx
msgid "OWNER"
msgstr "所有者"

#: src/components/MemberProjectProfilePopover.tsx
msgid "Participant"
msgstr "参与者"

#: src/components/InvitationsInbox.tsx
msgid "Pending"
msgstr "待处理"

#: src/components/ProjectMembersPage.tsx
msgid "People"
msgstr "成员"

#: src/components/ReadOnlyInteraction.tsx
msgid "Permission request"
msgstr "权限请求"

#: src/components/PrimaryNavigationRail.tsx
msgid "Personal navigation"
msgstr "个人导航"

#: src/components/PrimaryNavigationRail.tsx
msgid "Personal resources"
msgstr "个人资源"

#: src/components/ChannelContextMenu.tsx
#: src/components/PinButton.tsx
msgid "Pin"
msgstr "置顶"

#: src/components/ChannelRow.tsx
msgid "Pinned"
msgstr "已置顶"

#: src/components/PinnedChannelsSection.tsx
msgid "Pinned channels"
msgstr "已置顶频道"

#: src/components/ReadOnlyInteraction.tsx
msgid "Plan approval"
msgstr "计划审批"

#: src/components/ChannelSettingsModal.tsx
#: src/components/CreateChannelDialog.tsx
#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Private"
msgstr "私有"

#: src/components/ChannelRow.tsx
#: src/components/ChannelView.tsx
msgid "Private channel"
msgstr "私有频道"

#: src/components/InvitationsInbox.tsx
msgid "Processing…"
msgstr "处理中…"

#: src/components/HumanDetailView.tsx
msgid "Profile"
msgstr "资料"

#: src/components/ProjectPageHeader.tsx
msgid "Project"
msgstr "项目"

#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Project access is no longer available."
msgstr "已无法访问此项目。"

#: src/components/ProjectMembersPage.tsx
msgid "Project members"
msgstr "项目成员"

#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Project Members"
msgstr "项目成员"

#: src/components/CreateChannelDialog.tsx
msgid "Project members can preview and join."
msgstr "项目成员可以预览并加入。"

#: src/components/ZoneManagementDialog.tsx
msgid "Project members can see the Zone, including when it has no channels."
msgstr "项目成员可以看到此分区，即使其中没有频道。"

#: src/components/ServerMemberRemovalControl.tsx
msgid "PROJECT MEMBERSHIP"
msgstr "项目成员关系"

#: src/components/CreateServerModal.tsx
msgid "Project name"
msgstr "项目名称"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "PROJECT NAME"
msgstr "项目名称"

#: src/components/ServerSettings/ServerProfilePanel.tsx
#: src/lib/createServer.ts
msgid "Project name is required."
msgstr "请输入项目名称。"

#: src/lib/createServer.ts
msgid "Project name must be 100 characters or fewer."
msgstr "项目名称不能超过 100 个字符。"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Project profile"
msgstr "项目资料"

#: src/components/ServerSidebar.tsx
msgid "Project resources"
msgstr "项目资源"

#: src/components/ServerSettings/ServerProfilePanel.tsx
#: src/components/ServerSettingsSidebar.tsx
msgid "Project Settings"
msgstr "项目设置"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Project settings access denied"
msgstr "无权访问项目设置"

#: src/components/PrimaryNavigationRail.tsx
msgid "Projects"
msgstr "项目"

#: src/components/ProjectMemberRoleControl.tsx
msgid "Promote to Admin"
msgstr "提升为管理员"

#: src/components/ChannelSettingsModal.tsx
#: src/components/CreateChannelDialog.tsx
#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Public"
msgstr "公开"

#: src/components/ChannelList.tsx
msgid "Public channels"
msgstr "公开频道"

#: src/components/ChannelRow.tsx
#: src/components/ChannelView.tsx
#: src/components/ReadonlyBadge.tsx
msgid "Read-only"
msgstr "只读"

#: src/components/ReadonlyBadge.tsx
msgid "Read-only channel"
msgstr "只读频道"

#: src/components/ChannelSettingsModal.tsx
msgid "Read-only placement"
msgstr "位置不可修改"

#: src/components/ReadOnlyInteraction.tsx
msgid "Read-only request"
msgstr "只读请求"

#: src/components/MemberProjectProfilePopover.tsx
msgid "Recent work"
msgstr "近期工作"

#: src/components/InvitationsInbox.tsx
msgid "Refresh"
msgstr "刷新"

#: src/components/CreateChannelDialog.tsx
#: src/components/ZoneManagementDialog.tsx
msgid "Refresh Zones"
msgstr "刷新分区"

#: src/components/CreateChannelDialog.tsx
msgid "Refreshing…"
msgstr "正在刷新…"

#: src/components/ServerMemberRemovalControl.tsx
msgid "Removal impact is unavailable."
msgstr "无法获取移除影响。"

#: src/components/MemberList.tsx
#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Remove"
msgstr "移除"

#. placeholder {0}: target.display_name
#. placeholder {0}: user.display_name
#: src/components/KickConfirmModal.tsx
#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Remove {0}?"
msgstr "移除 {0}？"

#: src/components/ServerMemberRemovalControl.tsx
msgid "Remove {displayName} from Project"
msgstr "从项目中移除 {displayName}"

#: src/components/ServerMemberRemovalControl.tsx
msgid "Remove {displayName} from this Project?"
msgstr "从此项目中移除 {displayName}？"

#: src/components/ServerMemberRemovalControl.tsx
msgid "Remove Agent"
msgstr "移除 Agent"

#: src/components/ServerMemberRemovalControl.tsx
msgid "Remove from Project"
msgstr "从项目中移除"

#: src/components/ServerMembersPanel.tsx
msgid "Remove from this channel"
msgstr "从此频道中移除"

#: src/components/ServerMemberRemovalControl.tsx
msgid "Remove Human and access"
msgstr "移除用户及其访问权限"

#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Remove member"
msgstr "移除成员"

#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Removing a member only removes their Project access. Their channel and thread memberships are not changed."
msgstr "移除成员只会取消其项目访问权限，不会更改其频道或话题成员关系。"

#: src/components/ZoneChannelGroup.tsx
#: src/components/ZoneManagementDialog.tsx
msgid "Rename Zone"
msgstr "重命名分区"

#. placeholder {0}: zone.name
#: src/components/ZoneManagementDialog.tsx
msgid "Rename Zone: {0}"
msgstr "重命名分区：{0}"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Require an explicit @mention"
msgstr "必须明确 @ 提及"

#: src/components/ArchivedChannelsPanel.tsx
msgid "Restore"
msgstr "恢复"

#. placeholder {0}: channelDisplayName(channel!)
#: src/components/ChannelSettingsModal.tsx
msgid "Restore #{0}"
msgstr "恢复 #{0}"

#: src/components/CreateServerModal.tsx
#: src/components/ProjectMembersPage.tsx
#: src/components/Sidebar.tsx
msgid "Retry"
msgstr "重试"

#: src/components/ProjectMembersPage.tsx
msgid "Retry refresh"
msgstr "重试刷新"

#: src/components/InviteLinksModal.tsx
msgid "Revoke"
msgstr "撤销"

#: src/components/InviteLinksModal.tsx
msgid "Revoke invite link"
msgstr "撤销邀请链接"

#: src/components/InviteLinksModal.tsx
msgid "Revoke link"
msgstr "撤销链接"

#: src/components/InviteLinksModal.tsx
msgid "Revoke this invite link?"
msgstr "撤销此邀请链接？"

#: src/components/InviteLinksModal.tsx
msgid "Revoked"
msgstr "已撤销"

#: src/components/DescriptionEditor.tsx
msgid "Save"
msgstr "保存"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Save changes"
msgstr "保存更改"

#: src/components/ChannelSettingsModal.tsx
msgid "Save Changes"
msgstr "保存更改"

#: src/components/ZoneManagementDialog.tsx
msgid "Save name"
msgstr "保存名称"

#: src/components/ChannelSearchInput.tsx
msgid "Search channels"
msgstr "搜索频道"

#: src/components/ProjectMembersPage.tsx
msgid "Search members"
msgstr "搜索成员"

#: src/components/ProjectMembersPage.tsx
msgid "Search people…"
msgstr "搜索成员…"

#: src/components/CreateChannelDialog.tsx
msgid "Select members (optional)"
msgstr "选择成员（可选）"

#: src/components/ServerSettings/ServerProfilePanel.tsx
#: src/components/ServerSidebar.tsx
msgid "Settings"
msgstr "设置"

#: src/components/InviteLinksModal.tsx
msgid "Share a link to admit a Human to this Project. Invite URLs are never kept in this browser."
msgstr "分享链接以邀请用户加入此项目。邀请链接不会保存在此浏览器中。"

#. placeholder {0}: guild.name
#: src/components/PrimaryNavigationRail.tsx
msgid "Switch to {0}"
msgstr "切换到 {0}"

#: src/components/ChannelSettingsModal.tsx
msgid "Switch to Private"
msgstr "设为私有"

#: src/components/ChannelSettingsModal.tsx
msgid "Switch to Public"
msgstr "设为公开"

#: src/components/ChannelSettingsModal.tsx
msgid "Target Project"
msgstr "目标项目"

#: src/components/MemberProjectProfilePopover.tsx
msgid "Task context is unavailable right now."
msgstr "暂时无法获取任务信息。"

#: src/components/MemberProjectProfilePopover.tsx
msgid "Task contribution summary"
msgstr "任务贡献摘要"

#: src/components/ChannelView.tsx
#: src/components/ServerSidebar.tsx
msgid "Tasks"
msgstr "任务"

#: src/components/ChannelSettingsModal.tsx
msgid "The #general channel cannot be renamed"
msgstr "#general 频道无法重命名"

#: src/components/ProjectMembersPage.tsx
msgid "The agent was added, but the Project member list could not be refreshed."
msgstr "Agent 已添加，但无法刷新项目成员列表。"

#: src/components/DescriptionEditor.tsx
msgid "The channel description has unsaved changes that will be lost. Leave this page?"
msgstr "频道说明有未保存改动, 离开会丢失. 确认离开吗?"

#: src/components/ZoneManagementDialog.tsx
msgid "The name changes in the sidebar and channel breadcrumb. Channel links and access stay the same."
msgstr "名称将在侧栏和频道导航路径中更新，频道链接和访问权限保持不变。"

#: src/components/ProjectMembersPage.tsx
msgid "The Project member list refresh was superseded. Retry refresh to confirm the updated roster."
msgstr "项目成员列表的刷新已被新请求取代，请重试刷新以确认最新成员。"

#: src/hooks/useServerTransitionController.ts
msgid "The Project was created, but its channels could not be loaded. Retry switching Projects."
msgstr "项目已创建，但无法加载其中的频道。请重试切换项目。"

#: src/components/CreateChannelDialog.tsx
msgid "The selected Zone is no longer available. Refresh Zones and explicitly choose a location."
msgstr "所选分区已不可用，请刷新分区并重新选择位置。"

#: src/components/ZoneManagementDialog.tsx
msgid "The Zone name is invalid."
msgstr "分区名称无效。"

#: src/components/ServerMemberRemovalControl.tsx
msgid "This also removes this Human's directly owned Agents from this Project."
msgstr "这也会从此项目移除该用户直接拥有的 Agent。"

#: src/lib/readonly.ts
msgid "This channel is read-only. Only its creator can send messages."
msgstr "只读频道，仅创建者可发言。"

#: src/components/ProjectMemberRoleControl.tsx
msgid "This Human will keep Project access without Admin membership authority."
msgstr "此成员将保留项目访问权限，但不再拥有管理员权限。"

#: src/components/InvitationsInbox.tsx
msgid "This invitation has already been handled or its status has changed. Please refresh."
msgstr "该邀请已被处理或状态已变更，请刷新"

#: src/components/ChannelSettingsModal.tsx
msgid "This is a transfer, not a copy. The channel, all threads, messages, tasks, files, authorship, assignments, and activity history keep their IDs and remain complete."
msgstr "此操作会转移频道。频道、全部话题、消息、任务、文件、作者信息、分配关系和活动历史都将完整保留，ID 不变。"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "This name appears in the Project rail and switcher."
msgstr "此名称会显示在项目导航栏和项目切换器中。"

#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "This only removes Project access. It does not remove channel or thread memberships."
msgstr "这只会移除项目访问权限，不会移除频道或话题成员关系。"

#: src/components/ServerMemberRemovalControl.tsx
msgid "This removes only this Agent's Project membership."
msgstr "这只会移除此 Agent 的项目成员关系。"

#: src/components/ZoneManagementDialog.tsx
msgid "This Zone is no longer available. Refresh Zones to see the current groups."
msgstr "此分区已不可用，请刷新分区以查看当前分组。"

#: src/components/ZoneManagementDialog.tsx
msgid "This Zone is not empty. Archived channels also prevent deletion. No channels were changed."
msgstr "此分区不为空，已归档频道也会阻止删除。没有更改任何频道。"

#. placeholder {0}: topic || t`None`
#: src/components/ChannelStatusCard.tsx
msgid "Topic: {0}"
msgstr "主题：{0}"

#: src/components/ChannelSettingsModal.tsx
msgid "Type {channelName} to confirm"
msgstr "输入 {channelName} 以确认"

#: src/components/CreateChannelDialog.tsx
msgid "Unavailable Zone — choose a location"
msgstr "分区不可用 — 请选择位置"

#: src/components/MuteButton.tsx
msgid "Unmute"
msgstr "取消静音"

#: src/components/ChannelContextMenu.tsx
#: src/components/PinButton.tsx
msgid "Unpin"
msgstr "取消置顶"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Update the name and icon used for this Project."
msgstr "更新此项目的名称和图标。"

#. placeholder {0}: invite.consumed_uses
#. placeholder {1}: invite.max_uses
#: src/components/InviteLinksModal.tsx
msgid "Usage: {0}/{1}"
msgstr "使用次数：{0}/{1}"

#: src/lib/zoneNames.ts
msgid "Use 100 characters or fewer."
msgstr "请使用不超过 100 个字符。"

#: src/components/InviteLinksModal.tsx
msgid "Used up"
msgstr "已用完"

#: src/components/AddMemberModal.tsx
msgid "User email or ID"
msgstr "用户邮箱或 ID"

#. placeholder {0}: member.display_name
#: src/components/ProjectMembersPage.tsx
msgid "View {0} profile"
msgstr "查看 {0} 的资料"

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "View channels you created or joined. Creators can delete their own channels."
msgstr "查看你创建或加入的频道；创建者可以删除自己的频道 (soft delete)。"

#: src/components/DescriptionEditor.tsx
msgid "View edit history"
msgstr "查看编辑历史"

#: src/components/ProjectMembersPage.tsx
msgid "View Project profile"
msgstr "查看项目资料"

#: src/components/ZoneManagementDialog.tsx
msgid "Virtual · no Zone record"
msgstr "虚拟位置 · 无分区记录"

#: src/components/ChannelSettingsModal.tsx
#: src/components/CreateChannelDialog.tsx
msgid "Visibility"
msgstr "可见性"

#. placeholder {0}: i18n._(label.text)
#: src/components/VisibilityBadge.tsx
msgid "Visibility: {0}"
msgstr "可见性：{0}"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Waiting for the current status"
msgstr "当前状态待服务器返回"

#: src/components/ServerMembersPanel.tsx
msgid "When checked, this agent only responds when @mentioned"
msgstr "选中后，此 Agent 只会在被 @提及时响应"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "You don’t have permission to update this Project."
msgstr "你没有权限更新此项目。"

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "You have not created any channels yet."
msgstr "还没有你创建的频道。"

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "You have not joined any other channels yet."
msgstr "还没有其它已加入频道。"

#: src/components/ZoneManagementDialog.tsx
msgid "You no longer have permission to manage this Project’s Zones."
msgstr "你已无权管理此项目的分区。"

#: src/components/ProjectMembersPage.tsx
msgid "Your active Agents"
msgstr "你已启用的 Agent"

#: src/components/ZoneManagementDialog.tsx
msgid "Your change was saved, but Zones could not be refreshed. Refresh Zones to load the current state."
msgstr "更改已保存，但无法刷新分区。请刷新分区以加载当前状态。"

#: src/components/ChannelSettingsModal.tsx
#: src/components/CreateChannelDialog.tsx
msgid "Zone"
msgstr "分区"

#: src/components/ZoneManagementDialog.tsx
msgid "Zone name"
msgstr "分区名称"

#: src/components/ChannelSettingsModal.tsx
#: src/components/ChannelView.tsx
msgid "Zone unavailable"
msgstr "分区不可用"

#. placeholder {0}: group.name
#. placeholder {0}: zone.name
#: src/components/ChannelSettingsModal.tsx
#: src/components/ZoneChannelGroup.tsx
msgid "Zone: {0}"
msgstr "分区：{0}"

#: src/components/ServerSettings/ServerProfilePanel.tsx
#: src/components/ZoneManagementDialog.tsx
msgid "Zones"
msgstr "分区"
